import {TourStep} from "../models/tour-step.model";

export const DASHBOARD_TOUR_STEPS: TourStep[] = [

  {
    id: 'wallet',
    targetId: 'tour-dashboard-wallet',
    descriptionKey: 'TOUR.DASHBOARD_PAGE.Wallet',
  },
  {
    id: 'actions',
    targetId: 'tour-dashboard-actions',
    descriptionKey: 'TOUR.DASHBOARD_PAGE.Actions',
  },
  {
    id: 'accounts',
    targetId: 'tour-dashboard-accounts',
    descriptionKey: 'TOUR.DASHBOARD_PAGE.Accounts',
  },
  {
    id: 'referral',
    targetId: 'tour-dashboard-referral',
    descriptionKey: 'TOUR.DASHBOARD_PAGE.Referral',
  },
];
